module.exports = __webpack_public_path__ + "static/media/Desire.52825439.jpg";